var _style, _path, _path2, _path3, _circle, _path4, _path5, _circle2, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle3, _circle4, _path16, _path17, _path18, _circle5, _circle6, _path19, _path20, _path21, _circle7, _circle8, _path22, _path23, _path24, _circle9, _circle0, _path25, _path26, _path27, _circle1, _circle10, _path28, _path29, _path30, _circle11, _circle12, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _ellipse, _ellipse2, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieExplore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 344.9 208.2",
    style: {
      enableBackground: "new 0 0 344.9 208.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E3E3E3;}\n\t.st1{fill:#919191;}\n\t.st2{fill:#F8F8F8;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#F2F2F2;}\n\t.st5{fill:#454545;}\n\t.st6{fill:#C5CFD6;}\n\t.st7{fill:#B28B67;}\n\t.st8{fill:#191847;}\n\t.st9{fill:#D8D8D8;}\n\t.st10{fill:#C72F18;}\n\t.st11{fill:#DDE3E9;}\n\t.st12{fill:#F04E36;}\n\t.st13{fill:#66C3EC;}\n\t.st14{fill:none;stroke:#454545;stroke-miterlimit:10;}\n\t.st15{fill:#757575;}\n\t.st16{clip-path:url(#SVGID_00000000919389417426625920000010831569930974358660_);}\n\t.st17{fill:#BBD773;}\n\t.st18{opacity:0.15;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Photo_Background",
    className: "st0",
    d: "M201.3,10.5h54c2.2,0,4,1.8,4,4v33.1c0,2.2-1.8,4-4,4h-54c-2.2,0-4-1.8-4-4V14.5 C197.3,12.3,199.1,10.5,201.3,10.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mountains",
    className: "st1",
    d: "M220.8,22.3l-18.3,29.4h36.5L220.8,22.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Mountains-2",
    className: "st2",
    d: "M238.8,30.1l-16,21.5h32L238.8,30.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    className: "st3",
    cx: 245.6,
    cy: 24.2,
    r: 5.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Container",
    className: "st4",
    d: "M-65.6,0H88.8c4.4,0,8,3.6,8,8v160c0,4.4-3.6,8-8,8H-65.6c-4.4,0-8-3.6-8-8V8 C-73.6,3.6-70,0-65.6,0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Background",
    className: "st2",
    d: "M61.1,21.9h19.6c4.4,0,8,3.6,8,8v25.2c0,4.4-3.6,8-8,8H61.1c-4.4,0-8-3.6-8-8V29.9 C53.1,25.5,56.7,21.9,61.1,21.9z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    className: "st0",
    cx: 70.9,
    cy: 37.7,
    r: 8.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Name",
    className: "st0",
    d: "M59.7,47.8h22.4c0.8,0,1.5,0.7,1.5,1.5v0c0,0.8-0.7,1.5-1.5,1.5H59.7c-0.8,0-1.5-0.7-1.5-1.5v0 C58.2,48.5,58.8,47.8,59.7,47.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Name-2",
    className: "st0",
    d: "M63.8,52.9H78c0.8,0,1.5,0.7,1.5,1.5v0c0,0.8-0.7,1.5-1.5,1.5H63.8c-0.8,0-1.5-0.7-1.5-1.5v0 C62.2,53.6,62.9,52.9,63.8,52.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Header",
    className: "st5",
    d: "M-65.6,0H88.8c4.4,0,8,3.6,8,8v5.7H-73.6V8C-73.6,3.6-70,0-65.6,0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Background-2",
    className: "st2",
    d: "M61.1,67.2h19.6c4.4,0,8,3.6,8,8v82.7c0,4.4-3.6,8-8,8H61.1c-4.4,0-8-3.6-8-8V75.2 C53.1,70.7,56.7,67.2,61.1,67.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Data",
    className: "st0",
    d: "M66.2,76.3h9.3c2.2,0,4,1.8,4,4v5.2c0,2.2-1.8,4-4,4h-9.3c-2.2,0-4-1.8-4-4v-5.2 C62.2,78.1,64,76.3,66.2,76.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Data-2",
    className: "st0",
    d: "M66.2,93.6h9.3c2.2,0,4,1.8,4,4v4.7c0,2.2-1.8,4-4,4h-9.3c-2.2,0-4-1.8-4-4v-4.7 C62.2,95.4,64,93.6,66.2,93.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Data-3",
    className: "st0",
    d: "M66.2,110.4h9.3c2.2,0,4,1.8,4,4v4.7c0,2.2-1.8,4-4,4h-9.3c-2.2,0-4-1.8-4-4v-4.7 C62.2,112.2,64,110.4,66.2,110.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Data-4",
    className: "st0",
    d: "M66.2,144h9.3c2.2,0,4,1.8,4,4v4.7c0,2.2-1.8,4-4,4h-9.3c-2.2,0-4-1.8-4-4V148 C62.2,145.8,64,144,66.2,144z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Data-5",
    className: "st0",
    d: "M66.2,127.2h9.3c2.2,0,4,1.8,4,4v4.7c0,2.2-1.8,4-4,4h-9.3c-2.2,0-4-1.8-4-4v-4.7 C62.2,129,64,127.2,66.2,127.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Container-2",
    className: "st2",
    d: "M-63.4,22.4H47c1.1,0,2,0.9,2,2c0,0,0,0,0,0l0,0v19.8c0,1.1-0.9,2-2,2l0,0H-63.4 c-1.1,0-2-0.9-2-2V24.4C-65.5,23.3-64.6,22.4-63.4,22.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Label",
    className: "st0",
    d: "M-59.1,29.6h81.4c1,0,1.8,0.8,1.8,1.8v0c0,1-0.8,1.8-1.8,1.8h-81.4c-1,0-1.8-0.8-1.8-1.8v0 C-60.9,30.4-60.1,29.6-59.1,29.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Label-2",
    className: "st0",
    d: "M-59.1,35.5h53.4c1,0,1.8,0.8,1.8,1.8v0c0,1-0.8,1.8-1.8,1.8h-53.4c-1,0-1.8-0.8-1.8-1.8v0 C-60.9,36.3-60.1,35.5-59.1,35.5z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-3",
    className: "st0",
    cx: 36.8,
    cy: 34.3,
    r: 3.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    className: "st0",
    cx: 36.8,
    cy: 34.3,
    r: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Container-3",
    className: "st2",
    d: "M-63.4,50.4H47c1.1,0,2,0.9,2,2v0l0,0v15.8c0,1.1-0.9,2-2,2h0H-63.4c-1.1,0-2-0.9-2-2l0,0 V52.4C-65.5,51.3-64.6,50.4-63.4,50.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Label-3",
    className: "st0",
    d: "M-59.4,56.3h82c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-82c-0.8,0-1.5-0.7-1.5-1.5l0,0 C-60.9,57-60.2,56.3-59.4,56.3C-59.4,56.3-59.4,56.3-59.4,56.3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Label-4",
    className: "st0",
    d: "M-59.4,61.3h54.1c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5l0,0h-54.1 c-0.8,0-1.5-0.7-1.5-1.5l0,0C-60.9,61.9-60.2,61.3-59.4,61.3z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-4",
    className: "st0",
    cx: 36.8,
    cy: 60.3,
    r: 3.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-2",
    className: "st0",
    cx: 36.8,
    cy: 60.3,
    r: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Container-4",
    className: "st2",
    d: "M-61.5,74.3H45c2.2,0,4,1.8,4,4v11.8c0,2.2-1.8,4-4,4H-61.5c-2.2,0-4-1.8-4-4V78.3 C-65.5,76.1-63.7,74.3-61.5,74.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Label-5",
    className: "st0",
    d: "M-59.4,80.2h82c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-82c-0.8,0-1.5-0.7-1.5-1.5l0,0 C-60.9,80.9-60.2,80.2-59.4,80.2C-59.4,80.2-59.4,80.2-59.4,80.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Label-6",
    className: "st0",
    d: "M-59.4,85.2h54.1c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-54.1c-0.8,0-1.5-0.7-1.5-1.5 l0,0C-60.9,85.9-60.2,85.2-59.4,85.2z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-5",
    className: "st0",
    cx: 36.8,
    cy: 84.2,
    r: 3.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-3",
    className: "st0",
    cx: 36.8,
    cy: 84.2,
    r: 1.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Container-5",
    className: "st2",
    d: "M-63.4,146H47c1.1,0,2,0.9,2,2l0,0l0,0v15.8c0,1.1-0.9,2-2,2h0H-63.4c-1.1,0-2-0.9-2-2l0,0 v-15.8C-65.5,146.9-64.6,146-63.4,146C-63.4,146-63.4,146-63.4,146z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Label-7",
    className: "st0",
    d: "M-59.4,152h82c0.8,0,1.5,0.7,1.5,1.5l0,0l0,0c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0h-82 c-0.8,0-1.5-0.7-1.5-1.5l0,0l0,0C-60.9,152.6-60.2,152-59.4,152C-59.4,152-59.4,152-59.4,152z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Label-8",
    className: "st0",
    d: "M-59.4,156.9h54.1c0.8,0,1.5,0.7,1.5,1.5l0,0l0,0c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0h-54.1 c-0.8,0-1.5-0.7-1.5-1.5l0,0l0,0C-60.9,157.6-60.2,156.9-59.4,156.9C-59.4,156.9-59.4,156.9-59.4,156.9z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-6",
    className: "st0",
    cx: 36.8,
    cy: 155.9,
    r: 3.6
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-4",
    className: "st0",
    cx: 36.8,
    cy: 155.9,
    r: 1.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Container-6",
    className: "st2",
    d: "M-61.5,122.1H45c2.2,0,4,1.8,4,4V138c0,2.2-1.8,4-4,4H-61.5c-2.2,0-4-1.8-4-4v-11.8 C-65.5,123.9-63.7,122.1-61.5,122.1z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Label-9",
    className: "st0",
    d: "M-59.4,128.1h82c0.8,0,1.5,0.7,1.5,1.5l0,0l0,0c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0h-82 c-0.8,0-1.5-0.7-1.5-1.5l0,0l0,0C-60.9,128.7-60.2,128.1-59.4,128.1C-59.4,128.1-59.4,128.1-59.4,128.1z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Label-10",
    className: "st0",
    d: "M-59.4,133h54.1c0.8,0,1.5,0.7,1.5,1.5l0,0l0,0c0,0.8-0.7,1.5-1.5,1.5c0,0,0,0,0,0h-54.1 c-0.8,0-1.5-0.7-1.5-1.5l0,0l0,0C-60.9,133.7-60.2,133-59.4,133C-59.4,133-59.4,133-59.4,133z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-7",
    className: "st0",
    cx: 36.8,
    cy: 132,
    r: 3.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-5",
    className: "st0",
    cx: 36.8,
    cy: 132,
    r: 1.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Container-7",
    className: "st2",
    d: "M-61.5,98.2H45c2.2,0,4,1.8,4,4V114c0,2.2-1.8,4-4,4H-61.5c-2.2,0-4-1.8-4-4v-11.8 C-65.5,100-63.7,98.2-61.5,98.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Label-11",
    className: "st0",
    d: "M-59.4,104.1h82c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-82c-0.8,0-1.5-0.7-1.5-1.5 l0,0C-60.9,104.8-60.2,104.1-59.4,104.1C-59.4,104.1-59.4,104.1-59.4,104.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Label-12",
    className: "st0",
    d: "M-59.4,109.1h54.1c0.8,0,1.5,0.7,1.5,1.5l0,0c0,0.8-0.7,1.5-1.5,1.5h-54.1 c-0.8,0-1.5-0.7-1.5-1.5l0,0C-60.9,109.8-60.2,109.1-59.4,109.1z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-8",
    className: "st0",
    cx: 36.8,
    cy: 108.1,
    r: 3.6
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-6",
    className: "st0",
    cx: 36.8,
    cy: 108.1,
    r: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_35",
    className: "st6",
    d: "M94.8,208.1L94.8,208.1C94.8,208.1,94.8,208.1,94.8,208.1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_37",
    className: "st6",
    d: "M94.8,208.1L94.8,208.1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_39",
    className: "st6",
    d: "M94.8,208C94.8,208,94.8,208,94.8,208L94.8,208C94.9,208.3,94.8,208.1,94.8,208"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_41",
    className: "st6",
    d: "M94.8,208.1L94.8,208.1C94.8,208.2,94.8,208.1,94.8,208.1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_47",
    className: "st6",
    d: "M94.8,208.1C94.8,208.1,94.8,208.1,94.8,208.1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    className: "st3",
    d: "M16.1,9.9h-3V9.5h3V9.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    className: "st3",
    d: "M5.6,9V7.2H4.3V9H3.6V4.8h0.7v1.7h1.3V4.8h0.7V9H5.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    className: "st3",
    d: "M11.9,9l-1.2-3h0l0,3h-0.6V4.8h0.8l1.2,3h0l0-3h0.6V9H11.9z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    className: "st3",
    d: "M8.7,4.8H7.8L7.1,7.6L6.5,7.8l0.2,0.6l0.2-0.1L6.8,9h0.6l0.2-1l1.1-0.4L9.1,9h0.6L8.7,4.8z  M7.8,7.4l0.4-1.7h0l0.3,1.4L7.8,7.4z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Head-2",
    className: "st7",
    d: "M119.6,56.1l5.8-18.7c-2.2-2.8-3.2-6.4-2.7-10c1.7-10.5,16.2-6.9,18.6-1.3s0.9,19.2-2.9,19.8 c-1.5,0.3-4.6-1-7.6-3.2l0.8,14.4L119.6,56.1z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    className: "st8",
    d: "M130.9,42.2c-0.6-2.5-0.3-9.5-0.2-11.5c-0.1,0-0.2,0-0.4-0.1c-1.6-0.1-3.1,1.1-3.2,2.7 c-0.1,0.8,0.2,1.6,0.7,2.2c-0.8,0.9-1.6,1.9-2.6,2.8c-3.1-2.3-5.1-8.3-1.4-13.6c1-2.4,3.2-4.1,5.8-4.4c1.9-0.6,3.9-0.6,5.7,0.1 c2.5,0.4,4.9,1.2,7,2.5c-0.3,3.2-1,4-6.2,3.5c-1.4,0.7-2.7,1.8-3.6,3.1c0,0.1-0.1,9.6,2.8,9.8c2.9,0.3,5.6-1.4,6.9-1.3 c0.9,0.1,0.6,1.2-0.1,2.1c-0.6,0.7-3.1,1.1-3.2,2.3c-0.1,0.6,0.6,0.7,1.1,0.7c0.4,0,0.8,0.1,0.8,0.4c-0.1,1.1,0.1,3.2-1.8,3 C137,46.3,131.6,45.1,130.9,42.2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    className: "st9",
    d: "M117.1,112.3c22.3,0,40.3,28.5,40.3,63.6H76.8C76.8,140.7,94.9,112.3,117.1,112.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    className: "st10",
    d: "M128.6,61.8c0,0,19.4-0.6,26.2-6.4s-1.7-22-1.7-22h-10.3c0,0,4,9.5,1.2,14.2s-13.4-0.8-13.4-0.8 L128.6,61.8z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Shirt",
    className: "st11",
    d: "M123.8,45.8l10.3,1.6c0,19.6,4,41.2,6.7,54.9c0.2,1.2,0.5,3.6-1.1,3.6l-28.6-1.8 C112.9,81.4,115.3,59.6,123.8,45.8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Coat_Front",
    className: "st12",
    d: "M107.1,85.3c-2.3,7.8-3.7,15.7-4.4,23.8H135c6.2-15.8-7.7-63.3-7.7-63.3h-4.1 C113.2,60.1,110.1,72.1,107.1,85.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    className: "st5",
    d: "M139,31.3l34.5-5.9v13L139,34.5V31.3z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 173.5,
    cy: 31.9,
    rx: 2.9,
    ry: 6.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 173.5,
    cy: 31.9,
    rx: 2.4,
    ry: 6
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    className: "st7",
    d: "M145.8,27.4c3.6-1.6,7.6-0.7,7.9,2.4s-2.1,6.2-1.2,13.6l-5.9,1.3c0.4-3,0.4-6-0.2-9 C145.9,33.2,142.2,29,145.8,27.4z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    className: "st12",
    d: "M128.9,64.4c0,0,17.8-0.5,24.1-5.9c6.2-5.3,1.4-20.2,1.4-20.2h-9.4c0,0,0.8,8.7-1.8,13 c-2.6,4.3-15.8,0-15.8,0L128.9,64.4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    className: "st5",
    d: "M134.6,109.1c7.6,0,20.9,6,26.1,8.4s6.9,6.7,8.2,13.2c1.3,6.6,3.7,35.3,3.7,35.3l-8.1,1.3 c0,0-6.1-19.2-8.1-24.8s-10.7-9.8-10.7-9.8l-9.1-10.6L134.6,109.1z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    className: "st15",
    d: "M102.7,109.1c0,7-1.8,14.4,5.7,18c7.6,3.7,25.6,2.6,25.6,2.6l-20.7,10.6l2.3,7.7 c0,0,24.4-6.2,42.4-13.6s-1.8-15.8-8.4-18.9c-6.7-3-15-6.5-15-6.5L102.7,109.1z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe",
    d: "M106.5,146.1l0.9-0.3l1.4,6l6.5,16.6l1.7-0.7c0,0-1.3-11.6,0.7-19.9l-3.6-9.2l-9.3,3.2L106.5,146.1z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Shoe-2",
    d: "M168.3,175.5l0-0.9l6.1,0.7l17.8-0.8l-0.1-1.9c0,0-11.4-2.6-18.6-7.2l-9.8,0.4l0,9.9L168.3,175.5z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    d: "M257.4,146.5c1,0,1.8-0.6,2.1-1.5l44.2-123c0.4-1.2-0.2-2.5-1.4-2.9c0,0,0,0,0,0l0,0 c-1.2-0.4-2.5,0.2-2.9,1.4l-44.2,123c-0.4,1.2,0.2,2.5,1.4,2.9l0,0C256.9,146.4,257.2,146.5,257.4,146.5z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    className: "st13",
    d: "M332.1,101.3c-10.4,29-42.3,44-71.3,33.6l0,0c-29-10.4-44-42.3-33.6-71.3 c10.4-29,42.3-44,71.3-33.6l0,0C327.4,40.4,342.5,72.3,332.1,101.3C332.1,101.3,332.1,101.3,332.1,101.3L332.1,101.3z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M332.1,101.3c-10.4,29-42.3,44-71.3,33.6c0,0,0,0,0,0l0,0c-29-10.4-44-42.3-33.6-71.3 c10.4-29,42.3-44,71.3-33.6l0,0C327.4,40.4,342.5,72.3,332.1,101.3C332.1,101.3,332.1,101.3,332.1,101.3L332.1,101.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000001654755033746957430000008923632080545639591_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000001654755033746957430000008923632080545639591_)"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2983",
    className: "st17",
    d: "M308.2,51.9l3-8.3c0.4-1.1,1.6-1.6,2.6-1.2l32.9,11.8c1.1,0.4,1.6,1.6,1.2,2.6l-3,8.3 c-0.4,1.1-1.6,1.6-2.6,1.2l-32.9-11.8C308.4,54.2,307.8,53,308.2,51.9z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    className: "st17",
    d: "M378.8,108.4c2.1-7.7-2.2-15.8-9.8-18.4l-52.9-19c-7.6-2.8-16.1,0.8-19.4,8.2 c-3.2,7.7,0.5,16.5,8.1,19.7c0,0,0,0,0,0c0.2,0.1,0.4,0.2,0.7,0.3l12.6,4.5c1,0.4,1.5,1.4,1.1,2.4c0,0,0,0,0,0l0,0l0,0 c-0.3,1-1.4,1.5-2.4,1.1l0,0l-5.1-1.8c-4.1-1.5-8.6,0.7-10.1,4.7l0,0l0,0c-1.5,4.1,0.7,8.6,4.7,10.1c0,0,0,0,0,0l0,0l46.9,16.8 c4.1,1.5,8.6-0.7,10.1-4.7l0,0c1.5-4.1-0.7-8.6-4.7-10.1h0l1.3-3.6c8,2.4,16.3-2.2,18.7-10.1C378.8,108.5,378.8,108.5,378.8,108.4 z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2984",
    className: "st17",
    d: "M251.8,115.9l2.8-7.8c0.4-1,1.5-1.5,2.5-1.2l24.4,8.8c1,0.4,1.5,1.5,1.2,2.5l-2.8,7.8 c-0.4,1-1.5,1.5-2.5,1.2l-24.4-8.8C251.9,118,251.4,116.9,251.8,115.9z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    className: "st17",
    d: "M274.7,63.8l-14.8-5.3c-1.4-0.5-2.3-1.9-2-3.4c0.4-1.5,1.9-2.5,3.4-2.1c0.1,0,0.2,0.1,0.3,0.1 l6.3,2.3c3.6,1.3,7.6-0.6,8.8-4.2l0,0l0,0c1.3-3.6-0.6-7.6-4.2-8.8L232,27.7c-1.5-0.5-3.1,0.2-3.6,1.7l-2.8,7.7 c-0.5,1.5,0.2,3.1,1.7,3.6l6.3,2.3c1.4,0.5,2.3,1.9,2,3.4c-0.4,1.5-1.9,2.5-3.4,2.1c-0.1,0-0.2-0.1-0.3-0.1l-6.5-2.3 c-1.5-0.5-3.1,0.2-3.6,1.7l-2.8,7.7c-0.3,0.9-0.2,1.9,0.4,2.6l-2.2,6.2l-4.7-1.7c-3-1.1-6.3,0.2-7.8,3c-1.4,3-0.1,6.7,2.9,8.1 c0,0,0,0,0,0c0.2,0.1,0.4,0.2,0.5,0.2l41,14.7c3,1.1,6.3-0.2,7.8-3c1.4-3,0.1-6.7-2.9-8.1c-0.2-0.1-0.4-0.2-0.5-0.2l-13.1-4.7 c-1.6-0.6-2.4-2.3-1.8-3.9l0,0c0.6-1.6,2.3-2.4,3.9-1.8l0,0l27.3,9.8c3.6,1.3,7.6-0.4,9-3.9c1.4-3.6-0.3-7.6-3.9-9c0,0,0,0,0,0 C274.8,63.8,274.8,63.8,274.7,63.8z"
  })))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    d: "M279.5,147.8c36.1,0,65.3-29.2,65.3-65.2c0-27.6-17.3-52.2-43.2-61.5l-1.5,4.2c31.6,11.3,48.1,46.1,36.7,77.7 c-11.3,31.6-46.1,48.1-77.7,36.7c0,0-0.1,0-0.1,0l-1.5,4.2C264.6,146.5,272,147.8,279.5,147.8z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    d: "M300.8,167.8c-9.1,0-18.6-14-18.6-21.5h-5.8c0,7.4-9.5,21.5-18.6,21.5s-9.1,8.1-9.1,8.1h61.2 C309.9,175.9,309.9,167.8,300.8,167.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    className: "st18",
    d: "M227.1,63.6c7.8-21.7,28.1-36.4,51.2-36.9c-30.6,3.7-52.4,31.4-48.7,62 c2.5,20.9,16.6,38.7,36.5,45.8l0,0c6.4,2.3,13.3,3.4,20.1,3.3c-30.6,3.7-58.3-18.1-62-48.7C223.2,80.5,224.2,71.8,227.1,63.6 L227.1,63.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieExplore);
export default __webpack_public_path__ + "static/media/illustratie_explore.f9ec92edf2414ff4310f482e0e450a5e.svg";
export { ForwardRef as ReactComponent };